import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ggdy-bts"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_vxe_toolbar = _resolveComponent("vxe-toolbar");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_table = _resolveComponent("vxe-table");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_vxe_toolbar, null, {
    buttons: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_upload, {
      action: _ctx.data.upLoadUrl,
      "with-credentials": true,
      "on-success": _ctx.handleSuccess,
      "show-file-list": false,
      name: "file",
      limit: 1,
      accept: ".xls,.xlsx",
      "before-upload": _ctx.beforeAvatarUpload,
      ref: "uploadwlbj"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "l-button"
      }, "导入物料报价单", -1)])),
      _: 1,
      __: [0]
    }, 8, ["action", "on-success", "before-upload"])])]),
    _: 1
  }), _createVNode(_component_vxe_table, {
    id: "wlbjtable",
    onCheckboxChange: _ctx.selectionChange,
    onCheckboxAll: _ctx.selectAllChange,
    "max-height": "400",
    "custom-config": {
      storage: true
    },
    border: "",
    "show-overflow": "",
    data: _ctx.wlbjTableData,
    "column-config": {
      resizable: true
    },
    "edit-config": {
      trigger: 'click',
      mode: 'cell',
      showUpdateStatus: true,
      showInsertStatus: true
    },
    class: "ggdycss"
  }, {
    default: _withCtx(() => [_createVNode(_component_vxe_column, {
      field: "code",
      title: "物料编码",
      width: "250",
      align: "left"
    }), _createVNode(_component_vxe_column, {
      field: "name",
      title: "物料名称",
      width: "250",
      align: "left"
    }), _createVNode(_component_vxe_column, {
      field: "sku",
      title: "物料规格型号",
      align: "left"
    }), _createVNode(_component_vxe_column, {
      field: "price",
      title: "单价（￥）",
      align: "left"
    })]),
    _: 1
  }, 8, ["onCheckboxChange", "onCheckboxAll", "data"])]);
}